import React, { useState, useEffect } from 'react';
import renderHTML from 'react-render-html';
import TemplatePodcast from '../templates/Template-podcast'

const fs = require('fs');


function Page(props) {
    const { title, content, id, template } = props;
    const [ComponentToRender, setComponentToRender] = useState(null);
    let templateName ="";
    console.log(` In page --- title = ${JSON.stringify(title)}, id= ${JSON.stringify(id)},content=${JSON.stringify(content)} template=${template}  `)
    // Composant par défaut à afficher lorsque le template n'est pas disponible
    const DefaultComponent = () => (
        <div className='entry-content'>
            {renderHTML(content.rendered)}
        </div>
    );
    
    if (template) {
        templateName = template.replace(/\.[^.]+$/, '');
        templateName = templateName.charAt(0).toUpperCase() + templateName.slice(1);
    }
       
    return (
        <article id={'post-' + id} className={'page-type-page hentry post-' + id}>
            <header className='header-footer-group'>
                <h1 className='pagetitle'>{renderHTML(title.rendered)}</h1>
            </header>
            {template ? <TemplatePodcast /> : <DefaultComponent />}
        </article>
    );

    
    
}

export default Page;